import gql from 'graphql-tag';
const query = gql`
  mutation requestLink($params: LinkRequest!) {
    requestLink(params: $params)
  }
`;
export default query;
